import { render, staticRenderFns } from "./AdminLeadsByStatusInProgress.vue?vue&type=template&id=c70d3234&scoped=true&"
import script from "./AdminLeadsByStatusInProgress.vue?vue&type=script&lang=js&"
export * from "./AdminLeadsByStatusInProgress.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeadsByStatusInProgress.vue?vue&type=style&index=0&id=c70d3234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d3234",
  null
  
)

export default component.exports